import { render, staticRenderFns } from "./AnnouncementModal.vue?vue&type=template&id=ce55932e&"
import script from "./AnnouncementModal.vue?vue&type=script&lang=js&"
export * from "./AnnouncementModal.vue?vue&type=script&lang=js&"
import style0 from "./AnnouncementModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports